export default __webpack_public_path__ + "static/thumbnail-cb9f7d4e5559b746b09e896b22b3b881.png";